import { render, staticRenderFns } from "./InternalServerError.vue?vue&type=template&id=54e2ed14&scoped=true&"
import script from "./InternalServerError.vue?vue&type=script&lang=ts&"
export * from "./InternalServerError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2ed14",
  null
  
)

export default component.exports